<template>
  <div class="creatorForm row">
    <h2>Create a new test</h2>
    <div class="TestFormInfo ">
      <input type="text" id="Identifier" hidden />
      <div class="row">
        <div class="col-6 ">
          <div class="form-floating mb-3">
            <input type="text" class="form-control" id="floatingInput" v-model="newTest.title">
            <label for="floatingInput">Test Title</label>
          </div>
          <input hidden class="textInput small form-control" type="text" v-model="newTest.version"
            placeholder="Version 1.0.0" title="Version" />
        </div>
        <div class="col-6">
            <IscedSelector v-model="newTest.ISCED" />
          </div>
        

      </div>
      <div class="row">
        <div class="col">
          <!-- <div class="form-floating"> -->
            <SubjectSelector v-model="selectedSubject" />
            <!-- Debug: Selected subject: {{ selectedSubject }} -->
            <!-- <select class="form-select" v-model="newTest.Subject" name="subjects" id="subjects"
              aria-label="Floating label select example">
              <optgroup label="Core Subjects">
                <option value="english">English</option>
                <option value="mathematics">Mathematics</option>
                <option value="science">Science</option>
              </optgroup>
              <optgroup label="Humanities and Social Sciences">
                <option value="history">History</option>
                <option value="geography">Geography</option>
                <option value="religious-education">Religious Education (RE)</option>
                <option value="civics">Civics</option>
              </optgroup>
              <optgroup label="Languages">
                <option value="french">French</option>
                <option value="spanish">Spanish</option>
                <option value="german">German</option>
                <option value="italian">Italian</option>
                <option value="latin">Latin</option>
                <option value="mandarin-chinese">Mandarin Chinese</option>
              </optgroup>
              <optgroup label="Arts">
                <option value="art-design">Art and Design</option>
                <option value="music">Music</option>
                <option value="drama">Drama</option>
                <option value="dance">Dance</option>
              </optgroup>
              <optgroup label="Technology and Practical Subjects">
                <option value="design-technology">Design and Technology (D&T)</option>
                <option value="food-technology">Food Technology</option>
                <option value="computer-science">Computer Science</option>
              </optgroup>
              <optgroup label="Physical Education and Health">
                <option value="physical-education">Physical Education (PE)</option>
                <option value="health-social-care">Health and Social Care</option>
                <option value="pshe">Personal, Social, Health and Economic Education (PSHE)</option>
              </optgroup>
              <optgroup label="Optional or Specialized Subjects">
                <option value="business-studies">Business Studies</option>
                <option value="economics">Economics</option>
                <option value="psychology">Psychology</option>
                <option value="philosophy">Philosophy</option>
                <option value="sociology">Sociology</option>
                <option value="media-studies">Media Studies</option>
                <option value="law">Law</option>
              </optgroup>
              <optgroup label="Vocational Subjects">
                <option value="engineering">Engineering</option>
              </optgroup>
            </select> -->
            <!-- <label for="floatingSelect">Subjects</label>
          </div> -->

        </div>
        <div class="col">
          <div class="form-floating mb-3">
            <input class="form-control" id="domain" type="text" v-model="newTest.domain" title="Domain" />
            <label for="domain">Domain /sub-domain</label>
          </div>

        </div>
      </div>
      <div class="row">
        <div class="col">
          <textarea class="descript form-control" v-model="newTest.Description" placeholder="Description"
            title="Description"></textarea>

          <div class="form-floating mb-3">

            <input id="keywords" class="textInput form-control" type="text" v-model="newTest.Keywords"
              title="Key Words" />
            <label for="keywords">Key words</label>
          </div>

        </div>
      </div>
      <div class="row mt-3">
        <div class="col">
          <div class="form-floating mb-3">
            <input id="duration" class="textInput small form-control" type="number" v-model="newTest.duration"
              title="duration (mn)" />
            <label for="duration">Duration (minutes)</label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="form-floating">
            <select id="Tpath" class="form-select" v-model="newTest.progression" title="Test Path"
              aria-label="progression">
              <option value="linear">Linear</option>
              <option value="conditional">Conditional</option>
              <option disabled value="chosen">Chosen</option>
              <option value="adaptive">Adaptive</option>
            </select>
            <label for="Tpath">Test Progression</label>
          </div>
        </div>
      </div>
      
      <!-- Configuration CAT si mode adaptatif sélectionné -->
      <div v-if="newTest.progression === 'adaptive'" class="row">
        <div class="col-12">
          <CATNbQuestionsSimulator 
            v-model="newTest.CATParameters" 
            :form-data="newTest"
            @cat-test-created="handleCATTestCreated"
          />
        </div>
      </div>
      


      <!-- Boutons Create/Cancel uniquement pour les tests linéaires -->
      <div v-if="newTest.progression !== 'adaptive'" class="submitBar">
        <button @click="submitTest" class="btn btn-primary me-2" type="button">
          Create
        </button>
        <button @click="cancel" class="btn btn-secondary" type="button">
          Cancel
        </button>
      </div>
      
      <!-- Message informatif pour les tests CAT -->
      <div v-else class="cat-info-message">
        <div class="alert alert-info">
          <i class="fas fa-info-circle me-2"></i>
          <strong>Test Adaptatif (CAT)</strong><br>
          Configurez les paramètres CAT ci-dessus, puis utilisez le bouton de création dans la section de calibration.
        </div>
      </div>
    </div>
  </div>
</template>


<script setup>
import { reactive, ref, watch } from "vue";
import { v4 as uuidv4 } from 'uuid';
import { useTestStore } from '../stores/testStore'
import IscedSelector from "@/components/common/IscedSelector.vue";
import CATNbQuestionsSimulator from "@/components/CAT/CATNbQuestionsSimulator.vue";
import SubjectSelector from '@/components/common/SubjectSelector.vue'

// Déclaration des émetteurs
const emit = defineEmits(["close", "add-test"]);
const store = useTestStore()
const selectedSubject = ref('')

// Watcher pour synchroniser selectedSubject avec newTest.Subject
watch(selectedSubject, (newValue) => {
  if (newValue) {
    newTest.Subject = newValue;
    newTest.metadata.Subject = newValue;
  }
})

// Méthode pour annuler la création
const cancel = () => {
  emit("close"); // Émet l'événement 'close' pour informer le parent
};

let newTest = reactive({
  ID: uuidv4(),
  title: "",
  type: "WASPL",
  isNewElement: true,
  progression: "linear",
  CATParameters: {
    paliers: 4,
    confirmation: 3,
    echec: 3,
    calculatedItems: 0,
    randomizedItemOrder: true
  },
  metadata: {
    Author: "JANFIX",
    Created: new Date().toISOString().split("T")[0],
    Description: "",
    Difficulty: "",
    Subject: "",
    Keywords: []
  },
  pages: [{
    "id": uuidv4(),
    "label": "Page 1",
    "children": [],
    "Randomized": true
  }],
  elements: [],
  settings: {
    timeLimit: "",
    shuffleQuestions: true,
    shuffleoptions: true,
    NavigationPanel: false,
    progressBar: false,
    feedbackAllowed: true,
    directScore: true,
    countDown: false
  }
});

// Méthode pour soumettre le test
const submitTest = () => {
  if (!newTest.title || !newTest.type) {
    console.error("Le test doit contenir un titre et un type.");
    return;
  }

  // Pour les tests CAT, récupérer les données distribuées depuis le store
  let finalTestData = { ...newTest };
  
  if (newTest.progression === 'adaptive') {
    console.log('🎯 Test CAT détecté, récupération des données CATDistribution du store...');
    
    const storeData = store.testData || {};
    
    // Inclure les données CAT du store si elles existent
    if (storeData.CATDistribution) {
      finalTestData.CATDistribution = storeData.CATDistribution;
      console.log(`✅ CATDistribution incluse: ${Object.keys(storeData.CATDistribution.items || {}).length} niveaux`);
    }
    
    if (storeData.CATParameters) {
      finalTestData.CATParameters = storeData.CATParameters;
      console.log('✅ CATParameters inclus');
    }
    
    if (storeData.CATStructure) {
      finalTestData.CATStructure = storeData.CATStructure;
      console.log('✅ CATStructure incluse');
    }
  }

  console.log('📤 Envoi du test avec données complètes:', finalTestData);

  // Émet un événement pour informer le parent avec les données complètes
  emit("add-test", finalTestData);

  // Réinitialise le formulaire
  store.setTestData(finalTestData);
  // Ferme le formulaire
  emit("close");
};

// Méthode pour gérer la création d'un test CAT depuis le wizard
const handleCATTestCreated = (createdTest) => {
  console.log('✅ Test CAT créé depuis le wizard:', createdTest);
  
  // Émettre l'événement pour ajouter le test à la liste
  emit("add-test", createdTest);
  
  // Fermer le formulaire - l'utilisateur verra le test dans la liste et pourra cliquer dessus
  emit("close");
  
  // Message de confirmation
  setTimeout(() => {
    alert(`✅ Test CAT "${createdTest.title}" créé avec succès !

// 📊 Résumé :
// - ${createdTest.elements?.length || 0} items importés
// - ${createdTest.levels?.length || 0} niveaux de difficulté

👆 Cliquez sur votre test dans la liste pour l'ouvrir et commencer l'édition.`);
  }, 500);
};
</script>


<style scoped>
.textInput {
  margin-bottom: 10px;
  border-radius: 5px;
  border: 1px solid gainsboro;
}

.small {
  margin-right: 5px;
  width: 48%;
  display: inline;
}

select {
  margin-bottom: 10px;
  border-radius: 5px;
  border: 1px solid gainsboro;
}

.descript {
  margin-top: 2px;
  border-radius: 5px;
  border: 1px solid gainsboro;
  margin-bottom: 10px;
}

.creatorForm {
  border-radius: 5px;
  padding: 10px;
  border: 1px solid gainsboro;
}

.submitBar {
  margin-top: 20px;
}

.promptExample {
  margin: 5px;
}

.cat-info-message {
  margin-top: 20px;
}

.cat-info-message .alert {
  border-left: 4px solid #17a2b8;
  background-color: #f8f9fa;
}
</style>